import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';
import { buildDiscoverFieldsUrl } from '#helpers/buildDiscoverFieldsUrl.ts';
import { type DiscoverMovieFilters, type DiscoverTvFilters } from '../types.ts';

export const DISCOVER_FILTERS = 'discoverFilters';

export const useDiscoverFiltersParam = (): [
  DiscoverMovieFilters | DiscoverTvFilters,
  (value?: DiscoverMovieFilters | DiscoverTvFilters, pathnameOverride?: string) => void,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const setParam = (value?: DiscoverMovieFilters | DiscoverTvFilters, pathnameOverride?: string): void => {
    const url = buildDiscoverFieldsUrl(value, pathnameOverride ?? pathname, searchParams);
    router.push(url, { scroll: false });
  };

  // JSON.parse returns an any type
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return [JSON.parse(searchParams.get(DISCOVER_FILTERS) ?? '{}') as DiscoverMovieFilters | DiscoverTvFilters, setParam];
};
